import type { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { getSearchQuery } from '../selectors';
import type {
  PapiDaSharedDeviationSearch,
  PapiRequestDaSharedDeviationSearch,
} from '@wix/da-papi-types';
import type { FetchAction } from '../../Stream/base/types';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
import { FetchType } from '../../Stream/base/types';

export function fakeResponse({ params }): any {
  if (process.env.NODE_ENV !== 'production') {
    const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
    const { Chance } = require('chance'); // eslint-disable-line global-require
    if (window.doError) {
      return {
        error: 'invalid_request',
        error_description: 'Not logged in.',
        status: 'error',
      };
    }

    const { offset, limit } = params;

    const randomDeviations = new Chance().pickset(
      deviationsByType.image,
      limit
    );

    return {
      hasMore: offset + limit < deviationsByType.image.length,
      nextOffset: offset + limit,
      results: randomDeviations,
    };
  }
}

function* fetch(url: string, params: object) {
  const response = yield call(
    requestPuppy,
    {
      method: 'get',
      url,
      params,
    },
    fakeResponse
  );
  return response;
}

function* handleDeviationStreamFetch(action: FetchAction): SagaIterator {
  const { streamId } = action;

  const {
    offset,
    limit,
    searchQuery,
  }: {
    offset: ReturnType<typeof withOffset.selectors.getNextOffset>;
    limit: ReturnType<typeof selectors.getItemsPerFetch>;
    searchQuery: ReturnType<typeof getSearchQuery>;
  } = yield select(state => ({
    offset: withOffset.selectors.getNextOffset(state, streamId),
    limit: selectors.getItemsPerFetch(state, streamId),
    searchQuery: getSearchQuery(state),
  }));

  const params: PapiRequestDaSharedDeviationSearch = {
    include_scraps: true,
    q: searchQuery || undefined,
    offset,
    limit,
  };

  const response: PapiDaSharedDeviationSearch | false = yield call(
    fetch,
    'deviation/search',
    params
  );

  // TODO: proper error handling
  if (!response || isApiError(response)) {
    yield put(
      withOffset.actions.fetchFailure({
        streamId,
        fetchType: FetchType.Next,
        errorMsg: 'Failed to fetch',
      })
    );
    return;
  }

  const { hasMore, results } = response;
  const normalized = results && normalizeDeviations(results);

  yield put(
    withOffset.actions.fetchSuccess({
      streamId,
      hasMore: results ? !!hasMore : false,
      items: normalized?.result ?? [],
      entities: normalized?.entities ?? {},
    })
  );
}

export default handleDeviationStreamFetch;
